export const QUERY_KEY = {
  COMPANY_LIST: "companyList",
  INFINITE_COMPANY_LIST: "infiniteCompanyList",
  MY_INFO: "myInfo",
  TENANT_STATUS: "tenantStatus",
  AGENT_CONFIGS: "agentConfigs",
  CONVERSATION_LIST: "conversationList",
  CONVERSATION_MESSAGES: "conversationMessages",
};
